import FitAssistantVariation from '../Enums/FitAssistantVariation.ts';

export class InstructionTextHelper {
  // Roof racks and truck racks have no instructions until you choose a car, so we show a translation instead of leaving it blank
  public static HasInstructionText(variation: FitAssistantVariation): boolean {
    return variation === FitAssistantVariation.CarRoofRacks || variation === FitAssistantVariation.TruckRackSystem;
  }

  public static ShowInstructionText(): void {
    document.querySelector('.fa-hidden')?.classList.remove('d-none');
  }

  public static HideInstructionText(): void {
    document.querySelector('.fa-hidden')?.classList.add('d-none');
  }
}
